import { formatNumber } from 'utils/formatting'

export const getDcCoupledSections = (data) => {
  return [
    {
      sectionTitle: 'Availability',
      rows: [
        {
          label: 'Charge Power',
          value: formatNumber({
            value: data.onlineAvailableAcPowerChargekW,
            precision: 1,
            unit: ' kW',
          }),
        },
        {
          label: 'Discharge Power',
          value: formatNumber({
            value: data.onlineAvailableAcPowerDischargekW,
            precision: 1,
            unit: ' kW',
          }),
        },
        {
          label: 'Charge Energy',
          value: formatNumber({
            value: data.onlineAvailableAcEnergyChargekWh,
            precision: 1,
            unit: ' kWh',
          }),
        },
        {
          label: 'Discharge Energy',
          value: formatNumber({
            value: data.onlineAvailableAcEnergyDischargekWh,
            precision: 1,
            unit: ' kWh',
          }),
        },
      ],
    },
    {
      sectionTitle: 'Energy Capacity',
      rows: [
        {
          label: 'DC Online',
          value: formatNumber({
            value: data.onlineAvailableDcEnergykWh,
            precision: 1,
            unit: ' kWh',
          }),
        },
        {
          label: 'DC Nearline',
          value: formatNumber({
            value: data.nearlineDcEnergykWh,
            precision: 1,
            unit: ' kWh',
          }),
        },
        {
          label: 'AC Online',
          value: formatNumber({
            value: data.onlineAvailableAcEnergykWh,
            precision: 1,
            unit: ' kWh',
          }),
        },
        ...(data.contractualEnergykWh !== 0 &&
        isFinite(data.contractualEnergykWh) &&
        data.contractualEnergykWh < Number.MAX_VALUE
          ? [
              {
                label: 'Contractual',
                value: formatNumber({
                  value: data.contractualEnergykWh,
                  precision: 1,
                  unit: ' kWh',
                }),
              },
            ]
          : []),
      ],
    },
    {
      sectionTitle: 'AC REAL POWER',
      rows: [
        {
          label: 'Measured',
          value: formatNumber({
            value: data.measuredACkW,
            precision: 1,
            unit: ' kW',
            commas: true,
          }),
        },
        {
          label: 'AC Curtailment Limit',
          value: formatNumber({
            value: data.curtailmentLimitACkW,
            precision: 1,
            unit: ' kW',
          }),
        },
      ],
    },
    {
      sectionTitle: 'REACTIVE POWER',
      rows: [
        {
          label: 'Measured',
          value: formatNumber({
            value: data.measuredACKVAr,
            precision: 1,
            unit: ' kVAR',
          }),
        },
        {
          label: 'Commanded',
          value: formatNumber({
            value: data.commandedACKVAr,
            precision: 1,
            unit: ' kVAR',
          }),
        },
      ],
    },
    {
      sectionTitle: 'DC POWER',
      rows: [
        {
          label: 'Measured',
          value: formatNumber({
            value: data.measuredDCkW,
            precision: 1,
            unit: ' kW',
          }),
        },
        {
          label: 'Commanded',
          value: formatNumber({
            value: data.commandedDCkW,
            precision: 1,
            unit: ' kW',
          }),
        },
      ],
    },
  ]
}
